import { store } from '../redux/store'; // Adjust the path to your Redux store
import { logout } from '../redux/reducers/authReducers'
import { notification } from 'antd';
import { toggleSnackbar } from '../redux/reducers/optionsReducers';

export const onRequest = async (config) => {

    const controller = new AbortController();
    if (config.url && config.url.indexOf("login") < 0) {
    }
  
    return {
      ...config,
      signal: controller.abort(),
    };
};

export const onRequestError = (error) => {
  if (error.response === undefined) {
  }
  return error;
};

export const onResponse = (response) => {
    if (response) {
      if (response.data) {
        return response.data;
      } else return response;
    }
};

export const onResponseError = (error) => {

    if(error.response === undefined) {
      // notification.error({ message: error.message });
      return;
    } else if (error.response.status === 401) {
      console.log("error.request", error.request);
      console.log("error.response", error.response);
  
      if (
        error?.response?.config?.url &&
        error?.response?.config?.url?.indexOf("login") < 0
      ) {
      } else {
        return;
      }
  
      return;
    } else if (error.response.status === 400) {
      // notification.error({ message: errorMessage });
      return error.response.data;
    } else if (error.response.status === 403) {
        store.dispatch(logout());
        window.location.href = "/";
        if(error?.response?.data?.subscriptionExpired){
          store.dispatch(toggleSnackbar({
            open: true,
            severity: "error",
            position: "top-center",
            message: "Your subscription expired",
            description: "Please contact info@solmarinetech.com for an account"
          }));
        }

    } else if (error.response.status === 500) {
      return error.response.data
      return;
    }else if(error.response.status === 422){
      return error.response.data
    }else if(error.response.status === 404){
      return error.response.data
    }
     else {
      return;
    }
    return error;
};